import { useEffect } from 'react';
import { writeCookie } from '@belong/cookies';

export const URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES = ['ref', 'promo'];
export const PROMO_CODE_COOKIE_NAME = 's_refcmp';

export const usePromoCodeFromUrl = (): void => {
  useEffect(() => {
    const value = getPromoCodeFromUrl();
    if (value) {
      writeCookie(PROMO_CODE_COOKIE_NAME, value, {
        path: '/',
        httpOnly: false,
        sameSite: 'strict'
      });
    }
  }, []);
};

export const addPromoCode = (promoCode: string): void => {
  writeCookie(PROMO_CODE_COOKIE_NAME, promoCode, {
    path: '/',
    httpOnly: false,
    sameSite: 'strict'
  });
};

export const getPromoCodeFromUrl = (): string | undefined => {
  const { searchParams } = new URL(window.location.href);

  for (let i = 0; i < URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES.length; i += 1) {
    const param = URL_PARAMETERS_THAT_MAY_CONTAIN_PROMO_CODES[i];
    const valueInParam = searchParams.get(param);

    if (valueInParam) {
      return valueInParam;
    }
  }

  return undefined;
};
